// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5c00bd6b","239":"2dab80e0","667":"e57e76d3"}[chunkId] + ".chunk.js";
};